import { Action } from '@ngrx/store';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { BlankReceiptRequest } from './blank-receipts.interface';

export const BLANK_RECEIPT_CREATE = 'blankReceipt:BLANK_RECEIPT_CREATE';
export const BLANK_RECEIPT_CREATE_FAIL = 'blankReceipt:BLANK_RECEIPT_CREATE_FAIL';
export const BLANK_RECEIPT_CREATE_SUCCESS = 'blankReceipt:BLANK_RECEIPT_CREATE_SUCCESS';
export const BLANK_RECEIPT_LOCATION = 'blankReceipt:BLANK_RECEIPT_LOCATION';
export const BLANK_RECEIPT_LOCATION_FAIL = 'blankReceipt:BLANK_RECEIPT_LOCATION_FAIL';
export const BLANK_RECEIPT_LOCATION_SUCCESS = 'blankReceipt:BLANK_RECEIPT_LOCATION_SUCCESS';

export class BlankReceiptCreateAction implements Action {
  readonly type = BLANK_RECEIPT_CREATE;
  logPayload = true;

  constructor(readonly payload: { request: BlankReceiptRequest }) {}
}

export class BlankReceiptCreateSuccessAction implements Action {
  readonly type = BLANK_RECEIPT_CREATE_SUCCESS;

  constructor(readonly payload: { blob: Blob; filename: string }) {}
}

export class BlankReceiptCreateFailAction implements Action {
  readonly type = BLANK_RECEIPT_CREATE_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class BlankReceiptLocationAction implements Action {
  readonly type = BLANK_RECEIPT_LOCATION;
  logPayload = true;

  constructor(readonly payload: { customer: Customer }) {}
}

export class BlankReceiptLocationSuccessAction implements Action {
  readonly type = BLANK_RECEIPT_LOCATION_SUCCESS;

  constructor(readonly payload: { shipTos: Definition[] }) {}
}

export class BlankReceiptLocationFailAction implements Action {
  readonly type = BLANK_RECEIPT_LOCATION_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export type Actions =
  | BlankReceiptCreateAction
  | BlankReceiptCreateSuccessAction
  | BlankReceiptCreateFailAction
  | BlankReceiptLocationAction
  | BlankReceiptLocationSuccessAction
  | BlankReceiptLocationFailAction;
